// react
import React from 'react';
import ReactDOM from 'react-dom/client';
// style
import './index.css';
// app
import App from './App';
// react router
import { BrowserRouter } from "react-router-dom";
// bootstrap 
import 'bootstrap/dist/css/bootstrap.rtl.css';
import 'bootstrap/dist/css/bootstrap-grid.rtl.css'
import 'bootstrap/dist/js/bootstrap.bundle'
// react query
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './config/queryClientOptions';
// animate
// @ts-ignore
import AOS from "aos";
import 'aos/dist/aos.css';
AOS.init({
  duration: 1000,
  once: true,
});

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);


